import { doDefaultFetch } from '@nhl/fetch-helpers';

import actionCreators from './actionCreators';

const togglePlayers = actionCreators.togglePlayers;

const requestZipDownload = (season, team, playerIds) => async dispatch => {
    dispatch(actionCreators.requestZip());

    try {
        const response = await doDefaultFetch(
            `/site/api/headshots` +
            `?season=${season.id}` +
            `&team=${team.triCode}` +
            `&include=team.logos` +
            playerIds.reduce((acc, playerId) => acc + 'playerId=' + playerId + '&', '&')
        );

        dispatch(actionCreators.zipResponse(true));
        window.location.href = response.url;
    } catch (error) {
        dispatch(actionCreators.zipResponse(false))
    }
};

export default {
    togglePlayers,
    requestZipDownload
};